import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-352b6487"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "filter-text" }, "筛选 ", -1))
const _hoisted_2 = { class: "popup" }
const _hoisted_3 = { class: "filter-content" }
const _hoisted_4 = { class: "item-label" }
const _hoisted_5 = { class: "item-value-list xag-flex" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "filter-item form-footer device-replace-button-wrap" }
const _hoisted_8 = { class: "xag-flex" }

import { withDefaults, reactive, computed, ref, nextTick } from 'vue'
import { filterOptions } from '../definition'
import { FilterItem } from '@/types/device-replace-v3'
import { Button } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'filter-popup',
  props: {
    filterItems: { default: () => null },
    hasFilterItems: { type: Boolean, default: false },
    top: { default: 0 }
  },
  emits: ['update:filterItems'],
  setup(__props: any, { emit: emits }) {

const props = __props as { filterItems: FilterItem | null, hasFilterItems: boolean, top: number };



// 筛选项
const tempFilterItems: FilterItem = reactive({
  version: '',
  charge: '',
  control: '',
})
const filterPopupShow = ref(false)

function showFilterPopup() {
  filterPopupShow.value = !filterPopupShow.value
  if (filterPopupShow.value) {
    for (let key in props.filterItems) {
      tempFilterItems[key] = props.filterItems[key]
    }
  }
}
function setTempFilterItems(type: string, filterText: string) {
  let idx = tempFilterItems[type].indexOf(filterText)
  if (idx !== -1) {
    // 取消选中
    tempFilterItems[type] = ''
  } else {
    tempFilterItems[type] = filterText
  }
}
function hideFilterPopup() {
  filterPopupShow.value = false
}
function comfirmFilterItems() {
  let items = {}
  for (let key in tempFilterItems) {
    items[key] = tempFilterItems[key]
  }
  console.log('确认筛选', items)
  emits('update:filterItems', items)
  filterPopupShow.value = false
}
function resetFilterItems() {
  console.log('重置筛选')
  for (let key in tempFilterItems) {
    tempFilterItems[key] = ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["xag-flex activity-tag-filter", __props.hasFilterItems ? 'active' : '']),
      onClick: showFilterPopup
    }, [
      _hoisted_1,
      _createVNode(_component_van_icon, {
        name: __props.hasFilterItems ? '/images/icon_filter_active.svg' : '/images/icon_filter.svg',
        class: "filter-icon"
      }, null, 8, ["name"])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, { name: "modal" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", {
            class: "popup-overlay",
            style: _normalizeStyle(`top: ${__props.top}px;`)
          }, null, 4), [
            [_vShow, filterPopupShow.value]
          ])
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "content" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", {
            class: "popup-content",
            style: _normalizeStyle(`top: ${__props.top}px;`)
          }, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterOptions), (filter) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "filter-item",
                  key: filter.label
                }, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(filter.label), 1),
                  _createElementVNode("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.items, (option) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(["list-item", tempFilterItems[filter.type].indexOf(option.value) !== -1 ? 'checked' : '']),
                        key: option.value,
                        onClick: ($event: any) => (setTempFilterItems(filter.type, option.value))
                      }, _toDisplayString(option.label), 11, _hoisted_6))
                    }), 128))
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(Button), {
                    square: "",
                    type: "success",
                    class: "xa-vant-button-cancel btn-cancel",
                    onClick: resetFilterItems
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 重置 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    square: "",
                    type: "success",
                    class: "xa-vant-button",
                    onClick: comfirmFilterItems
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("确定")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ], 4), [
            [_vShow, filterPopupShow.value]
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})